import React, { useMemo, useCallback } from 'react';
import isNil from 'lodash/isNil';
import includes from 'lodash/includes';
import compact from 'lodash/compact';

import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { ID } from '../../../../types';

import {
  MultiSelectExtendedDataType,
  MultiSelectChangeCallbackType
} from '../../../../helpers/MultiSelect/types';

import { useTranslate } from '../../../../common/hooks/useTranslate';

import { MultiSelect } from '../../../../helpers/MultiSelect';

import { tasksStatuses } from '../../tasksConstants';

interface TasksStatusesMultiSelectProps {
  value: ID[];
  availableStatuses: ID[];
  autoFocus?: boolean;
  onChange: (value: ID[]) => void;
}

function TasksStatusesMultiSelect({
  value,
  availableStatuses,
  autoFocus,
  onChange
}: TasksStatusesMultiSelectProps) {
  const { t } = useTranslate();
  const data = useMemo<MultiSelectExtendedDataType[]>(() => {
    return compact(
      tasksStatuses.map(({ value, i18nLabel }) =>
        isNil(availableStatuses) || includes(availableStatuses, value)
          ? {
              value: value,
              label: t(i18nLabel)
            }
          : null
      )
    );
  }, [t, availableStatuses]);

  const multiSelectValue = useMemo<MultiSelectExtendedDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(data, ['value', item]))
      : [];
  }, [value, data]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectExtendedDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={data}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default TasksStatusesMultiSelect;
